























































































import Vue from 'vue';
import Dinero from 'dinero.js';

export default Vue.extend({
  name: 'PaymentOptionButton',
  props: {
    totalPrice: {
      type: Number,
    },
    downPaymentPercentage: {
      type: Number,
    },
    valuePerMonth: {
      type: Number,
    },
    installments: {
      type: Number,
    },
    selected: {
      type: Boolean,
    },
    currencyCode: {
      type: String,
    },
    origin: {
      type: String,
      required: true,
    },
  },

  computed: {
    downPaymentValue() {
      return Dinero({ amount: this.totalPrice })
        .percentage(this.downPaymentPercentage)
        .getAmount();
    },
    isDownPaymentEqualToInstallments() {
      if (!this.downPaymentPercentage) {
        return true;
      }

      const oneDollarInCents = 100;
      const difference = Math.abs(Number(this.valuePerMonth) - Number(this.downPaymentValue));

      if (difference < oneDollarInCents) {
        return true;
      }
      return false;
    },
    paymentsText() {
      return (`${
        (this.downPaymentPercentage > 0 && this.downPaymentPercentage !== 100)
          ? Number(this.installments) + 1
          : this.installments
      } ${this.downPaymentPercentage === 100 ? 'Payment' : 'Payments'}`);
    },
  },
});
